<template>
  <vs-popup background-color="rgba(0,0,0,.6)" background-color-popup="rgb(248,248,248)" fullscreen
            :active.sync="isActiveLocal" title="Stok Limitleri" v-esc="escape">
    <vs-row vs-type="flex" vs-w="12">
      <vs-row vs-type="flex" vs-w="12" class="pb-1">
        <vs-col vs-type="flex" vs-w="12">
          <v-select v-model="selectedBranch" itemid="id" label="name" class="w-full"
                    placeholder="Şube Seçimi.." :options="branches" :clearable="false">
          </v-select>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="py-1">
        <vs-col vs-type="flex" vs-w="12">
          <vs-input @input="setFilter" v-model="searchText" placeholder="Stok İsmi Ara"
                    class="stock-order-filter-input bg-white text-dark weight-600 w-full text-small" size="small"/>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="py-2">
        <vs-col vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" class="mb-2 border-bottom mr-6">
              <vs-col class="py-1 px-2" vs-type="flex" vs-w="3">
                <span class="text-primary weight-600 text-small">İsim</span>
              </vs-col>
              <vs-col class="py-1 px-2" vs-type="flex" vs-w="3">
                <span class="text-primary weight-600 text-small">Sipariş Birimi</span>
              </vs-col>
              <vs-col class="py-1 px-2" vs-type="flex" vs-w="3" vs-justify="center">
                <span class="text-primary weight-600 text-small">Minimum</span>
              </vs-col>
              <vs-col class="py-1 px-2" vs-type="flex" vs-w="3" vs-justify="center">
                <span class="text-primary weight-600 text-small">Maksimum</span>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" style="overflow-y: auto;max-height: 69vh;">
              <div v-for="(stock,index) in filteredStocks" :key="stock.id"
                   :class="{'bg-white' : index % 2 == 0,'bg-secondary2' : index % 2 == 1}"
                   class="p-1 vs-row flex w-full">
                <vs-col vs-type="flex" vs-w="3" class="py-1 px-2" vs-align="center">
                  <span class="text-dark weight-600 text-smaller">{{ stock.name }}</span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="3" class="py-1 px-2" vs-align="center">
                  <span class="text-dark weight-600 text-smaller">{{ stock.unitName }}</span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="3" class="py-1 px-2" vs-align="center">
                  <vs-input v-model="stock.minimum" class="w-full text-dark weight-600" size="small" />
                </vs-col>
                <vs-col vs-type="flex" vs-w="3" class="py-1 px-2" vs-align="center">
                  <vs-input v-model="stock.maximum" class="w-full text-dark weight-600" size="small" />
                </vs-col>
              </div>
            </vs-row>
          </vs-row>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="pt-2" vs-justify="flex-end">
        <vs-button color="success" @click="submit">Kaydet
        </vs-button>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
import {getStocksForLimit, setStockLimits} from "@/api/Stock";
import {getBranchNameList2} from "@/api/Branch";
export default {
  name: "SetStockLimits",
  data() {
    return {
      selectedBranch: null,
      stocks: null,
      searchText: "",
      branches: [],
      filteredStocks: []
    }
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isActiveLocal: {
      get() {
        return this.isActive
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  watch: {
    selectedBranch(val) {
      if (val) {
        getStocksForLimit(val.id).then(res => {
          if (res && res.status === 200) {
            this.stocks = res.data
            this.filteredStocks = this.stocks;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Stoklar Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        })
      }
    }
  },
  methods: {
    setFilter: _.debounce(function (val) {
      let result = this.stocks.filter(function (str) {
        return str.name.toLowerCase().includes(val.toLowerCase())
      });
      this.filteredStocks = result
    }, 1000),
    escape() {
      if (this.isActiveLocal == true) this.isActiveLocal = false
    },
    submit() {
      this.stocks.forEach(stock => {
        if(stock.minimum) {
          stock.minimum = parseFloat(stock.minimum)
        }
        if(stock.maximum) {
          stock.maximum = parseFloat(stock.maximum)
        }
      })
      setStockLimits(this.stocks).then(res => {
        if (res && res.status === 200) {
          this.$vs.notify({
            color: 'success',
            title: 'Başarılı !',
            text: 'Stok Limitleri Güncellendi !'
          });
          this.escape()
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata : ' + res.status,
            text: 'Stok Limitleri Güncellenemedi !'
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata !',
          text: 'Sunucu Bağlantı Hatası !'
        });
      })
    },
    getBranches() {

    }
  },
  created: async function() {
    this.branches = await getBranchNameList2();
  }
}
</script>

<style scoped>

</style>
